import React, { useState } from "react";
import {
  Dialog,
  Flex,
  Button,
  Box,
  TextArea,
  AlertDialog,
} from "@radix-ui/themes";
import api from "axios_interceptor/interceptor";

const SendFeedbackDialog = () => {
  const [feedback, setFeedback] = useState("");
  const [isErrorAlertOpen, setIsErrorAlertOpen] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const handleFeedbackChange = (event) => {
    setFeedback(event.target.value);
  };

  const handleSendClick = async () => {
    try {
      const response = await api.post("utils/feedback", {
        feedback,
      });
      if (response.data.code === 400) {
        setIsErrorAlertOpen(true);
      } else if (response.data.code === 200) {
        setIsAlertOpen(true);
      }
      setFeedback("");
    } catch (error) {
      console.error("Error submitting feedback:", error);
    }
  };

  const handleCancelClick = () => {
    setFeedback("");
  };

  return (
    <div>
      <Dialog.Root>
        <Dialog.Trigger>
          <Button
            size="2"
            variant="soft"
            color="orange"
            style={{ cursor: "pointer" }}
          >
            Send Feedback
          </Button>
        </Dialog.Trigger>

        <Dialog.Content maxWidth="600px">
          <Dialog.Title>Send Feedback</Dialog.Title>
          <Dialog.Description size="2" mb="4">
            Share your feedback with us for a chance to win 10 tokens! Your
            thoughtful insight helps us grow and improve your experience.
          </Dialog.Description>

          <Box maxWidth="600px">
            <TextArea
              placeholder="Send feedback..."
              value={feedback}
              onChange={handleFeedbackChange}
            />
          </Box>

          <Flex gap="3" mt="4" justify="end">
            <Dialog.Close>
              <Button
                variant="soft"
                color="gray"
                style={{ cursor: "pointer" }}
                onClick={handleCancelClick}
              >
                Cancel
              </Button>
            </Dialog.Close>
            <Dialog.Close>
              <Button
                color="green"
                style={{ cursor: "pointer" }}
                onClick={handleSendClick}
              >
                Send
              </Button>
            </Dialog.Close>
          </Flex>
        </Dialog.Content>
      </Dialog.Root>

      <AlertDialog.Root
        open={isErrorAlertOpen}
        onOpenChange={setIsErrorAlertOpen}
      >
        <AlertDialog.Content maxWidth="450px">
          <AlertDialog.Title>Error</AlertDialog.Title>
          <AlertDialog.Description size="2">
            Your feedback is too short. Please try again.
          </AlertDialog.Description>

          <Flex gap="3" mt="4" justify="end">
            <AlertDialog.Cancel asChild>
              <Button
                variant="soft"
                color="red"
                style={{ cursor: "pointer" }}
                onClick={() => setIsErrorAlertOpen(false)}
              >
                Ok
              </Button>
            </AlertDialog.Cancel>
          </Flex>
        </AlertDialog.Content>
      </AlertDialog.Root>

      <AlertDialog.Root open={isAlertOpen} onOpenChange={setIsAlertOpen}>
        <AlertDialog.Content maxWidth="450px">
          <AlertDialog.Title>Sucess</AlertDialog.Title>
          <AlertDialog.Description size="2">
            Thank you for your valuable feedback.
          </AlertDialog.Description>

          <Flex gap="3" mt="4" justify="end">
            <AlertDialog.Cancel asChild>
              <Button
                variant="soft"
                color="green"
                style={{ cursor: "pointer" }}
                onClick={() => setIsAlertOpen(false)}
              >
                Ok
              </Button>
            </AlertDialog.Cancel>
          </Flex>
        </AlertDialog.Content>
      </AlertDialog.Root>
    </div>
  );
};

export default SendFeedbackDialog;
